module.exports = __webpack_public_path__ + "img/allif-tv-screen.595b4f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/allif-tv-screen.svg
// module id = 1480
// module chunks = 1